import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

const today = () => new Date().toISOString().slice(0, 10);

// Hold / Complete / Verify & Close all take exactly the same shape - a date
// and mandatory remarks - so they share one modal rather than three
// near-identical ones. Close adds an optional Customer Comment, which by
// design is entered by whoever verifies, never by the technician on site.
//
// The date is sent as a plain YYYY-MM-DD: OnHoldDate, CompletedDate and
// ClosedDate are all SQL `date` columns, so a time would be discarded anyway
// (and is exactly what makes the History timeline show a fake 12:00 AM - see
// ActivityTimeline.jsx).
const RemarksActionModal = ({
  show,
  onClose,
  onConfirm,
  isSaving,
  title,
  dateLabel,
  remarksLabel,
  remarksPlaceholder,
  confirmLabel,
  confirmVariant = "primary",
  withCustomerComment = false,
  intro,
}) => {
  const [date, setDate] = useState(today());
  const [remarks, setRemarks] = useState("");
  const [customerComment, setCustomerComment] = useState("");

  useEffect(() => {
    if (show) {
      setDate(today());
      setRemarks("");
      setCustomerComment("");
    }
  }, [show]);

  return (
    <Modal show={show} onHide={isSaving ? undefined : onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {intro && <p className="text-muted small">{intro}</p>}
        <div className="mb-3">
          <label className="form-label">{dateLabel}</label>
          <input type="date" className="form-control" value={date} onChange={(e) => setDate(e.target.value)} />
        </div>
        <div className="mb-3">
          <label className="form-label">{remarksLabel} <span className="text-danger">*</span></label>
          <textarea
            className="form-control"
            rows={3}
            value={remarks}
            placeholder={remarksPlaceholder}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>
        {withCustomerComment && (
          <div className="mb-1">
            <label className="form-label">Customer's comment <span className="text-muted">(optional)</span></label>
            <textarea
              className="form-control"
              rows={2}
              value={customerComment}
              placeholder="What the customer said about the job when you verified it"
              onChange={(e) => setCustomerComment(e.target.value)}
            />
            <small className="text-muted">
              Saved onto the service report. Leave blank to skip it entirely.
            </small>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={isSaving}>Cancel</Button>
        <Button
          variant={confirmVariant}
          disabled={isSaving || !remarks.trim() || !date}
          onClick={() => onConfirm({ date, remarks: remarks.trim(), customerComment: customerComment.trim() || undefined })}
        >
          {isSaving ? "Saving..." : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RemarksActionModal;
